import { IconButton } from '../../../IconButton';
import React from 'react';
import { useAiTextGenerationContext } from '../../../../context/AiTextGenerationContext';

export interface HistoryProps extends React.HTMLAttributes<HTMLDivElement> {}

export const History: React.FC<HistoryProps> = ({ className }) => {
  const { generatedTextHistory, activeHistoryPage, updateActiveHistoryPage } = useAiTextGenerationContext();

  if (!generatedTextHistory || generatedTextHistory.length <= 1) {
    return null;
  }

  return (
    <div className={className}>
      <IconButton
        name="caret_left"
        size="md"
        aria-label="show previous AI response"
        onClick={() => updateActiveHistoryPage?.(activeHistoryPage - 1)}
        datatestid="ai-history-back"
        arialabel="Ai History Back"
      />
      <span>
        {activeHistoryPage + 1}/{generatedTextHistory?.length}
      </span>
      <IconButton
        name="caret_right"
        size="md"
        aria-label="show next AI response"
        onClick={() => updateActiveHistoryPage?.(activeHistoryPage + 1)}
        datatestid="ai-history-forward"
        arialabel="Ai History Forward"
      />
    </div>
  );
};
